export default __webpack_public_path__ + "static/media/36I-102747_-17358_0.4d00a24f.jpg";